<template>
  <a
    :href="href"
    target="_blank"
    style="display: table-cell; align-items: center; text-align:center;align-items: center; justify-content: center; border-radius: 8px; padding: 15px 15px; width: 200px; vertical-align: middle; text-align: center; text-decoration: none; line-height: 1.5; font-size: 16px; font-weight: 500;"
    :style="{
      backgroundColor: bgColor,
      color: textColor,
      margin: margin,
      border: borderBtn,
    }"
  >
    {{ label }}
  </a>
</template>

<script>
export default {
  name: 'UiLeadButton',
  props: {
    label: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '#FFFFFF',
    },
    bgType: {
      type: String,
      default: 'accept',
    },
    margin: {
      type: String,
      default: '10px',
    },
  },
  computed: {
    bgColor() {
      const bgGreen = ['accept', 'reassign']
      const bgRed = ['reject', 'stop']
      if (bgRed.includes(this.bgType)) {
        return '#FFFFFF'
      }
      if (bgGreen.includes(this.bgType)) {
        return '#00C31F'
      }
      return '#9B9B9B'
    },
    textColor() {
      const colorRed = ['reject', 'stop']
      if (colorRed.includes(this.bgType)) {
        return '#f91f40'
      }
      return this.color
    },
    borderBtn() {
      const bgRed = ['reject', 'stop']
      if (bgRed.includes(this.bgType)) {
        return '2px solid #f91f40'
      }
      return 'none'
    },
  },
}
</script>
